module.exports = __webpack_public_path__ + "media/images/icon-fire-85e7881b20971ad3b880f04443e02f10.svg";